import {
  login,
  getUserByToken,
  Authlogin,
  AppScanCodeLogin,
  GetEnterprisetypeByDeptID,
  Logout,
  getNToken,
  getTokenTime
} from '@/api/user'
import userStorage from '@/utils/storage/userStorage'
import tokenStorage from '@/utils/storage/tokenStorage'
import menuStorage from '@/utils/storage/menuStorage'
import baseStorage from '@/utils/storage/baseStorage'
import { v4 as uuidv4 } from 'uuid';
const state = {
  token: tokenStorage.getToken(),
  tokenTimer: null,
  tokenInterTime: 0,
  external: false,
  Ischangepassword: userStorage.getIschangepassword(),
  UnionId: userStorage.getUnionId(),
  userInfo: userStorage.getUserInfo(),
  userMenu: menuStorage.get(),
  PerfectInformation: userStorage.getPerfectInformation(),
  Verifyphonenumber: userStorage.getVerifyphonenumber(), //是否需要验证手机号
  Useridentity: userStorage.getUseridentity(), //用户身份
  UserOnline: userStorage.getUserOnline()//用户在线ID
}

const mutations = {
  mSetVerifyphonenumber: (state, value) => {
    state.Verifyphonenumber = value
    userStorage.setVerifyphonenumber(value)
  },
  mSetUseridentity: (state, value) => {
    state.Useridentity = value
    userStorage.setUseridentity(value)
  },
  mSetExternal: (state, external) => {
    state.external = external;
  },
  mSetTokenInterTime: (state, tokenexpiredtime) => {
    state.tokenInterTime = tokenexpiredtime;
  },
  mSetTokenTimer: (state, tokenTimer) => {
    state.tokenTimer = tokenTimer;
  },
  mSetToken: (state, token) => {
    state.token = token
  },
  mSetUser: (state, value) => {
    state.userInfo = value
  },
  mSetUserImage: (state, value) => {
    state.userInfo.ImageUrl = value
  },
  setMenu: (state, value) => {
    state.userMenu = value
  },
  mSetUserOnline: (state, value) => {
    state.UserOnline = value
    userStorage.setUserOnline(value)
  },
  //是否需要完善信息
  mSetPerfectInformation(state, value) {
    state.PerfectInformation = value
    userStorage.setPerfectInformation(value)
  },
  msetUnionId: (state, value) => {
    userStorage.setUnionId(value)
  }, 
  msetIschangepassword: (state, value) => {
    userStorage.setIschangepassword(value)
  },
}

const actions = {
  aSetExternal({
    commit,
    state
  }, view) {
    commit("mSetExternal", view);
  },
  //查询token剩余时间，并且生成轮询方法更新token
  aGetTokenTime({
    commit,
    state
  }, view) {
    let that = this;
    return new Promise((resolve, reject) => {
      function getNTokenFun() {
        return new Promise((resolve2, reject2) => {
          getNToken()
            .then(res => {
              const {
                usertoken,  
                tokenexpiredtime
              } = res.Data;
              commit("mSetTokenInterTime", tokenexpiredtime);
              commit("mSetToken", usertoken);
              tokenStorage.setToken(usertoken);
              tokenStorage.setTokenTime(tokenexpiredtime);
              mapMyself();
              resolve2(res);
            })
            .catch(error => {
              commit("mSetToken", null);
              clearInterval(that.tokenTimer);
              tokenStorage.removeToken();
              //location.reload()
              reject2(error);
            });
        });
      }

      function mapMyself() {
        if (state.token) {
          clearInterval(that.tokenTimer);
          that.tokenTimer = setInterval(async () => {
            getNTokenFun();
          }, (state.tokenInterTime - 2) * 60 * 1000);
          commit("mSetTokenTimer", that.tokenTimer);
        } else {
          clearInterval(that.tokenTimer);
        }
      }

      getTokenTime()
        .then(res => {
          commit("mSetTokenInterTime", res.Data);
          tokenStorage.setTokenTime(res.Data);
          if (state.tokenInterTime < 2) {
            //有效期时间少于2分钟
            getNTokenFun();
          } else {
            mapMyself();
          }
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  //用户登录
  aLogin({
    commit
  }, userInfo) {

    return new Promise((resolve, reject) => {
      login(userInfo).then(res => {
        if (res.Code === 200 || res.Code === 10002) {
          const {
            usertoken,
            userinfo
          } = res.Data
          commit('mSetToken', usertoken)
          tokenStorage.setToken(usertoken)
          commit('mSetUser', userinfo)
          commit('mSetVerifyphonenumber', 'false')
          userStorage.setUserInfo(userinfo)
          //设置前端自动生成在线用户ID，
          //后端写入数据库，用来标识用户唯一登录，解决singalr刷新页面重新创建新连接，造成多条在线记录。
          commit('mSetUserOnline', uuidv4())
          GetEnterprisetypeByDeptID({
            DeptID: userinfo.DeptID
          }).then(result => {
            commit('mSetUseridentity', result.Data)
          })
        }
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //微信和qq授权后登录系统
  aAuthlogin({
    commit
  }, openID) {

    return new Promise((resolve, reject) => {
      Authlogin({
        openID: openID
      }).then(result => {
        if (result.Code === 200 || result.Code === 10002) {
          const {
            usertoken,
            userinfo
          } = result.Data
          commit('mSetToken', usertoken)
          tokenStorage.setToken(usertoken)
          commit('mSetUser', userinfo)
          //设置前端自动生成在线用户ID，
          //后端写入数据库，用来标识用户唯一登录，解决singalr刷新页面重新创建新连接，造成多条在线记录。
          commit('mSetUserOnline', uuidv4())

          if (userinfo.LoginName == null) {
            commit('mSetVerifyphonenumber', 'true')
          }
          userStorage.setUserInfo(userinfo)
          GetEnterprisetypeByDeptID({
            DeptID: userinfo.DeptID
          }).then(result => {
            commit('mSetUseridentity', result.Data)
          })
        }
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //APP扫码登陆
  aAppScanCodeLogin({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      AppScanCodeLogin({
        Userid: params.Userid,
        RandomCode: params.RandomCode
      }).then(result => {
        if (result.Code === 200 || result.Code === 10002) {
          const {
            usertoken,
            userinfo
          } = result.Data
          commit('mSetToken', usertoken)
          tokenStorage.setToken(usertoken)
          commit('mSetUser', userinfo)
          //设置前端自动生成在线用户ID，
          //后端写入数据库，用来标识用户唯一登录，解决singalr刷新页面重新创建新连接，造成多条在线记录。
          commit('mSetUserOnline', uuidv4())

          if (userinfo.LoginName == null) {
            commit('mSetVerifyphonenumber', 'true')
          }
          userStorage.setUserInfo(userinfo)
          GetEnterprisetypeByDeptID({
            DeptID: userinfo.DeptID
          }).then(result => {
            commit('mSetUseridentity', result.Data)
          })
        }
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取用户信息
  aGetUser({
    commit,
    state
  }) {
    if (!state.userInfo) {
      var userinfo = userStorage.getUserInfo()
      if (userinfo) {
        commit('mSetUser', userInfo)
      }
    }
  },
  //获取用户信息
  aSetUser({
    commit
  }, value) {
    commit('mSetUser', value)
    userStorage.setUserInfo(value)
  },

  // 用户退出
  logout({
    commit,
    state
  }, params) {
    let that = this;
    return new Promise((resolve, reject) => {
      //清除用户信息
      commit('mSetToken', '');
      commit('mSetVerifyphonenumber', 'false')
      commit('mSetUseridentity', '')
      commit('mSetUser', {})
      commit('mSetUserOnline', '')
      commit('msetUnionId', '')
      //清除菜单信息
      that.dispatch('permission/aClearAll');
      //退出signalr连接
      that.dispatch("message/aLoginOut");
      baseStorage.clearStorage();
      //退出方法
      Logout({
        userid: params.Userid
      }).then(res => {
        if (res.Data != "200") {
          reject('退出失败，请稍后重试！')
        }
      }).catch(error => {
        reject(error)
      });
      resolve()
    })
  },

  //移除缓存
  resetToken({
    commit
  }) {
    let that = this;
    return new Promise(resolve => {
      //清除用户信息
      commit('mSetToken', '');
      commit('mSetVerifyphonenumber', 'false')
      commit('mSetUseridentity', '')
      commit('mSetUserOnline', '')
      commit('msetUnionId', '')
      //清除菜单信息
      that.dispatch('permission/aClearAll');
      baseStorage.clearStorage()

      resolve()
    })
  },
  //更新用户信息
  updateUser({
    commit
  }, token) {
    return new Promise((resolve, reject) => {
      commit('mSetToken', token)
      tokenStorage.setToken(token)
      getUserByToken().then(res => {
        if (res) {
          commit('mSetVerifyphonenumber', 'false')
          commit('mSetUser', res.Data)
          userStorage.setUserInfo(res.Data)
          GetEnterprisetypeByDeptID({
            DeptID: res.Data.DeptID
          }).then(result => {
            commit('mSetUseridentity', result.Data)
          })
          resolve()
        } else {
          reject('token错误,请重新登录！')
        }

      }).catch(error => {
        reject(error)
      })
    })
  },
  //更新用户信息
  updateToken({
    commit
  }, token) {
    return new Promise((resolve, reject) => {
      commit('mSetToken', token)
      tokenStorage.setToken(token)
    })
  },


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js